import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useMaterialUIController, setLayout } from "../../context";
import MaterialBox from "../../components/MaterialBox";
import DashboardFooter from "./components/Footer";
import DashboardNavbar from "./components/Navbar";
import { Box } from "@mui/material";

function DashboardLayout({ children, isCheckedIn, onClick }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <>
      <MaterialBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
          position: "relative",
          minHeight: "100vh",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",

          [breakpoints.up("lg")]: {
            marginLeft: miniSidenav ? pxToRem(72) : pxToRem(220),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },

          [breakpoints.up("xl")]: {
            marginLeft: miniSidenav ? pxToRem(72) : pxToRem(220),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        })}
      >
        <DashboardNavbar onClick={onClick} isCheckedIn={isCheckedIn} />

        {/* Page Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: { xs: 1.5, sm: 2, md: 2.5 },
            pt: 1.5,
            pb: 5,
          }}
        >
          {children}
        </Box>
      </MaterialBox>

      {/* Sticky Footer */}
      <Box
        sx={({ breakpoints, functions: { pxToRem } }) => ({
          position: "fixed",
          bottom: 0,
          right: 0,
          width: "100%",
          zIndex: 10,
          [breakpoints.up("lg")]: {
            width: `calc(100% - ${miniSidenav ? pxToRem(72) : pxToRem(220)})`,
          },
          [breakpoints.up("xl")]: {
            width: `calc(100% - ${miniSidenav ? pxToRem(72) : pxToRem(220)})`,
          },
        })}
      >
        <DashboardFooter />
      </Box>
    </>
  );

}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;